<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">Product Tags</h1>

    <portal to="quickActions" >
      <div>
        <inertia-link :href="route('manage.products')" class="border px-2 py-1 bg-white rounded">Back to Products</inertia-link>
        <inertia-link :href="route('manage.products.tags.create')" class="border px-2 py-1 bg-primary-500 text-white rounded">Create Tag</inertia-link>
      </div>
    </portal>

    <div>
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pt-6 pb-4">Label</th>
            <th class="pt-6 pb-4">Preset</th>
            <th class="pt-6 pb-4">Preview</th>
            <th class="pt-6 pb-4">Published</th>
            <th class="pt-6 pb-4"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in tags" class="text-left font-bold">
            <td class="border-t text-sm">{{item.label}}</td>
            <td class="border-t text-sm">{{item.preset}}</td>
            <td class="border-t text-sm p-2"><span class="rounded py-1 px-2 font-bold" :class="presets[item.preset]">{{ item.label }}</span></td>
            <td class="border-t text-sm">
              <span v-if="item.publish">Yes</span>
              <span v-else>No</span>
            </td>
            <td class="border-t text-sm">
              <inertia-link :href="route('manage.products.tags.edit', {tag: item.id })">Edit</inertia-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Admin/Layout'
const tagPresets = {
  yellowish: "bg-gradient-to-r from-yellow-500 to-red-500 text-white",
  blueish: "bg-gradient-to-r from-sky-500 to-teal-500 text-white",
  greenish: "bg-gradient-to-r from-emerald-500 to-lime-500 text-white",
  red: "bg-red-500 text-white",
  blue: "bg-blue-500 text-white",
  green: "bg-green-500 text-white",
  yellow: "bg-yellow-300 text-gray-800"
};


export default {
  metaInfo: { title: 'Manage Product Tags' },
  layout: Layout,
  props: {
    tags: Array
  },
  data() {
    return {
      presets: tagPresets,
    }
  }
}
</script>
